<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template #activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon small>
          fas fa-edit
        </v-icon>
      </v-btn>
    </template>
    <task-form
      :task="task"
      :specs="specs"
      :categories="categories"
      @update="update"
      @valid="v => (valid = v)"
    >
      <template #title>
        <v-icon class="mb-2 mr-2">
          fas fa-edit
        </v-icon><span>Edit Schedule Task </span>
        <v-spacer />
        <v-btn
          icon
          :disabled="loading"
          text
          @click="dialog = false"
        >
          <v-icon color="gray">
            fas fa-times
          </v-icon>
        </v-btn>
      </template>
      <template #message>
        <v-alert
          v-if="errorMsg !== ''"
          type="error"
        >
          {{ errorMsg }}
        </v-alert>
      </template>
      <template #actions>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!valid"
          :elevation="0"
          @click="saveTask"
        >
          Save
        </v-btn>
      </template>
    </task-form>
  </v-dialog>
</template>

<script>
import { scheduler, user } from '@rhitics/core'
import { cloneDeep } from 'lodash'
import TaskForm from './TaskForm.vue'

export default {
  name: 'TaskEditDialog',
  components: { TaskForm },
  props: {
    task: {
      type: Object,
      default: undefined
    },
    specs: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      dialog: false,
      valid: true,
      form: {
        ownerId: NaN,
        name: '',
        specId: -1,
        spec: {
          id: NaN,
          name: '',
          categoryId: NaN,
          description: '',
          method: 'GET',
          endpoint: '',
          schema: {},
          headersSchema: {}
        },
        payload: {},
        headers: {},
        timezone: '',
        cron: '',
        active: false,
        useJob: false,
      },
      loading: false,
      errorMsg: ''
    }
  },

  methods: {
    update(form) {
      this.form = form
    },
    async saveTask() {
      if (!this.valid) return
      this.loading = true
      const postPayload = this.getPostPayload(this.form)
      try {
        await scheduler.task.update(postPayload)
        this.dialog = false
        this.$emit('update')
      } catch (error) {
        this.errorMsg = error.message
      }
      this.loading = false
    },
    getPostPayload(form) {
      let postData = cloneDeep(form)
      postData.payload = JSON.stringify(postData.payload)
      postData.headers = JSON.stringify(postData.headers)
      delete postData.timezone
      delete postData.ownerId
      delete postData.updatedAt
      delete postData.createdAt
      delete postData.spec
      delete postData.owner
      return postData
    }
  }
}
</script>
